import Vue from 'vue'
import Router from 'vue-router'
//import store from './store/store'

Vue.use(Router)

/*
const isAuthenticated = (to, from, next) => {
  if (! store.getters.logged) {
    next('login')
  } else {
    next()
  }
}
*/

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "login" */ './views/user/login.vue')
    },
    {
      path: '/register',
      name: 'register',
      component: () => import(/* webpackChunkName: "login" */ './views/user/register.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/user/login.vue')
    },
    {
      path: '/logout',
      name: 'logout'
    },
    {
      path: '/credential/:project_id/:project_uid',
      name: 'credential',
      component: () => import('./views/credential/index.vue'),
      meta: {
        guarded: false
      },
    },
    {
      path: '/dashboard/:project_id/:project_uid',
      name: 'dashboard',
      redirect: 'dashboard/:project_id/:project_uid/info',
      component: () => import('./views/dashboard/index.vue'),
      children: [
        {
          path: 'financial',
          name: 'dashboardFinancial',
          component: () => import ('./views/dashboard/financial')
        },
        {
          path: 'info',
          name: 'dashboardInfo',
          component: () => import ('./views/dashboard/info')
        },
      ]
    },
    {
      path: '/plans',
      name: 'plans',
      component: () => import('./views/plan'),
      meta: {
        guarded: false
      }
    },
    {
      path: '/admin',
      name: 'admin',
      redirect: 'admin/dashboard',
      component: () => import('./views/admin/index.vue'),
      meta: {
        guarded: true
      },
      children: [
        {
          path: 'dashboard',
          name: 'adminDashboard',
          component: () => import ('./views/admin/dashboard')
        },
        {
          path: 'plan',
          name: 'adminPlan',
          redirect: 'plan/list',
          component: () => import ('./views/admin/plan'),
          children: [
            {
              path: 'list',
              name: 'adminPlanList',
              component: () => import ('./views/admin/plan/list'),
            },
            {
              path: 'create',
              name: 'adminPlanCreate',
              component: () => import ('./views/admin/plan/create'),
            },
            {
              path: ':plan_id/edit',
              name: 'adminPlanEdit',
              component: () => import ('./views/admin/plan/edit'),
            }
          ]
        },
        {
          path: 'project',
          name: 'adminProject',
          redirect: 'project/list',
          component: () => import ('./views/admin/project'),
          children: [
            {
              path: 'list',
              name: 'adminProjectList',
              component: () => import ('./views/admin/project/list'),
            },
            {
              path: 'create',
              name: 'adminProjectCreate',
              component: () => import ('./views/admin/project/create'),
            },
            {
              path: ':project_id/dashboard',
              name: 'adminProjectDashboard',
              component: () => import ('./views/admin/project/edit'),
            },
            {
              path: ':project_id/edit',
              name: 'adminProjectEdit',
              component: () => import ('./views/admin/project/edit'),
            }
          ]
        }
      ]
    }
  ]
})
